import LoanList from '@/views/loan/LoanList.vue'

export default [
    {
        // 上班族方案列表
        path: '/loan/list/:id',
        name: 'LoanList',
        component: LoanList
    },
    {
        // 上班族方案详情
        path: '/loan/detail/:id',
        name: 'LoanDetail',
        component: () => import('@/views/loan/LoanDetail')
    },
    {
        // 贷款渠道
        path: '/loan/channel',
        name: 'LoanChannel',
        component: () => import('@/views/loan/LoanChannel')
    },
    {
        // 贷款表单
        path: '/loan/from',
        name: 'LoanFrom',
        component: () => import('@/views/loan/LoanFrom')
    }
]
